/* eslint-disable @typescript-eslint/no-explicit-any */
import hasOwnProperty from './hasOwnProperty';
import isObject from '../shared/isObject';

type Comparator = (one: unknown, two: unknown) => boolean;

const isEqual: Comparator =
  Object.is ||
  ((one, two) => {
    let typeOne = typeof one;
    if (typeOne !== typeof two) {
      return false;
    }
    if (typeOne !== 'number') {
      return one === two;
    }
    if (isNaN(one as any)) {
      return isNaN(two as any);
    }
    if (one === 0 && two === 0) {
      // +0 and -0 should not be considered equal.
      return 1 / one === 1 / two;
    }
    return one === two;
  });

export default function shallowEqual(one: unknown, two: unknown) {
  if (Array.isArray(one) && Array.isArray(two)) {
    let length = one.length;
    if (length !== two.length) {
      return false;
    }
    for (let i = 0; i < length; i++) {
      if (!isEqual(one[i], two[i])) {
        return false;
      }
    }
    return true;
  }
  if (isObject(one) && isObject(two)) {
    let keys = Object.keys(one);
    if (keys.length !== Object.keys(two).length) {
      return false;
    }
    for (let key of keys) {
      if (!hasOwnProperty(two, key) || !isEqual(one[key], two[key])) {
        return false;
      }
    }
    return true;
  } else {
    return isEqual(one, two);
  }
}
